import React, { useState } from 'react';
import { Menu, X, Phone, Instagram } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-yellow-700/20">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-20">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/eah2h1s1_logo%20empresa.jpeg"
              alt="La Rent Car de la Isla"
              className="h-16 md:h-20 object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('vehiculos')}
              className="text-white/70 hover:text-yellow-600 transition-colors duration-300 text-base font-medium"
            >
              Vehículos
            </button>
            <button 
              onClick={() => scrollToSection('por-que')}
              className="text-white/70 hover:text-yellow-600 transition-colors duration-300 text-base font-medium"
            >
              Por Qué Elegirnos
            </button>
            <button 
              onClick={() => scrollToSection('como-funciona')}
              className="text-white/70 hover:text-yellow-600 transition-colors duration-300 text-base font-medium"
            >
              Cómo Funciona
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="text-white/70 hover:text-yellow-600 transition-colors duration-300 text-base font-medium"
            >
              Contacto
            </button>
            <a 
              href="tel:+18099640099"
              className="flex items-center gap-2 text-white/70 hover:text-yellow-600 transition-colors duration-300"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm">+1 (809) 964-0099</span>
            </a>
            <a 
              href="mailto:larentcardelaisla@gmail.com"
              className="flex items-center gap-2 text-white/70 hover:text-yellow-600 transition-colors duration-300"
            >
              <span className="text-sm">Email</span>
            </a>
            <a 
              href="https://instagram.com/rentcardelaisla"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 hover:text-yellow-600 transition-colors duration-300"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-yellow-700/20">
            <nav className="flex flex-col gap-4">
              <button 
                onClick={() => scrollToSection('vehiculos')}
                className="text-white/70 hover:text-yellow-600 transition-colors duration-300 text-left py-2"
              >
                Vehículos
              </button>
              <button 
                onClick={() => scrollToSection('por-que')}
                className="text-white/70 hover:text-yellow-600 transition-colors duration-300 text-left py-2"
              >
                Por Qué Elegirnos
              </button>
              <button 
                onClick={() => scrollToSection('como-funciona')}
                className="text-white/70 hover:text-yellow-600 transition-colors duration-300 text-left py-2"
              >
                Cómo Funciona
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="text-white/70 hover:text-yellow-600 transition-colors duration-300 text-left py-2"
              >
                Contacto
              </button>
              <a 
                href="tel:+18099640099"
                className="flex items-center gap-2 text-white/70 hover:text-yellow-600 transition-colors duration-300 py-2"
              >
                <Phone className="w-4 h-4" />
                <span>+1 (809) 964-0099</span>
              </a>
              <a 
                href="https://instagram.com/rentcardelaisla"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-yellow-600 transition-colors duration-300 py-2"
              >
                <Instagram className="w-5 h-5" />
                <span>@rentcardelaisla</span>
              </a>
              <a 
                href="mailto:larentcardelaisla@gmail.com"
                className="flex items-center gap-2 text-white/70 hover:text-yellow-600 transition-colors duration-300 py-2"
              >
                <span>larentcardelaisla@gmail.com</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
